import styled, { css, keyframes } from 'styled-components';

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const slideDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  60% {
    opacity: 1;
    transform: translateY(6px);
  }
  80% {
    transform: translateY(-2px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Wrapper = styled.div`
  position: relative;
  height: 2.75rem;
  flex: 1;
  min-width: 0;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    background: transparent;
    overflow: hidden;
    animation: ${slideDown} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 3rem;
      z-index: 2;
      pointer-events: none;
    }

    &::before {
      left: 0;
      background: linear-gradient(
        to right,
        ${theme.colors.background[80]},
        transparent
      );
    }

    &::after {
      right: 0;
      background: linear-gradient(
        to left,
        ${theme.colors.background[80]},
        transparent
      );
    }
  `}
`;

type TrackProps = {
  $duration: number;
  $paused: boolean;
};

export const Track = styled.div<TrackProps>`
  display: flex;
  align-items: center;
  gap: 2.5rem;
  animation: ${scroll} ${({ $duration }) => $duration}s linear infinite;
  animation-play-state: ${({ $paused }) => ($paused ? 'paused' : 'running')};
  will-change: transform;
`;

export const SponsorItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 2.75rem;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }

  img {
    height: 100%;
    width: auto;
    max-width: 8rem;
    object-fit: contain;
  }
`;
